<div style="max-height: 90vh;">
    <mat-toolbar fxLayout="row" fxLayoutAlign="center center">
        <strong>Add Inventory Item</strong>
    </mat-toolbar>

    <form [formGroup]="addItemForm">
        <div fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="space-between start">
                <lgd-text fxFlex="45" controlName="number" label="Number"
                          telemetry="Edit-Number-AddInventoryItem-Inventory">
                </lgd-text>

                <lgd-select fxFlex="45" controlName="status" label="Status" [options]="statusesObservable"
                            aria-label="Selection-Status-AddInventoryItem-Inventory" style="margin: 0 1rem;">
                </lgd-select>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between start">
                <lgd-text controlName="description" label="Description"
                          telemetry="Edit-Description-AddInventoryItem-Inventory">
                </lgd-text>

                <lgd-text controlName="detailedDescription" label="Detailed Description"
                          telemetry="Edit-DetailedDescription-AddInventoryItem-Inventory" style="margin: 0 1rem;">
                </lgd-text>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between start">
                <lgd-typeahead fxFlex="45" controlName="location" label="Location"
                               (searchTextChanged)="lookupLocations($event)" [options]="locationsObservable"
                               telemetry="Edit-Location-AddInventoryItem-Inventory">
                </lgd-typeahead>

                <lgd-typeahead fxFlex="35" #stockLocationLookup controlName="stockLocation" label="Stock Location"
                               (searchTextChanged)="lookupStockLocations($event)" [options]="stockLocationsObservable"
                               telemetry="Edit-StockLocation-AddInventoryItem-Inventory">
                </lgd-typeahead>

                <div fxFlex="10">
                    <forge-icon-button (click)="addStockLocation()">
                        <forge-icon *ngIf="!newStockLocation" name="add"></forge-icon>
                        <forge-icon *ngIf="newStockLocation" name="remove"></forge-icon>
                    </forge-icon-button>
                </div>
            </div>

            <div *ngIf="newStockLocation" fxLayout="row" fxLayoutAlign="space-between start">
                <lgd-text fxFlex="45" controlName="locationCode" label="Location Code"
                          telemetry="Edit-LocationCode-AddInventoryItem-Inventory">
                </lgd-text>

                <lgd-text fxFlex="45" controlName="locationDescription" label="Location Description"
                          telemetry="Edit-LocationDescription-AddInventoryItem-Inventory">
                </lgd-text>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between start" class="mb20">
                <lgd-select fxFlex="45" controlName="locationStatus" label="Location Status"
                            [options]="statusesObservable"
                            aria-label="Selection-LocationStatus-AddInventoryItem-Inventory">
                </lgd-select>

                <lgd-typeahead fxFlex="35" #classLookup controlName="class" label="Class"
                               telemetry="Edit-Class-AddInventoryItem-Inventory"
                               (searchTextChanged)="lookupClasses($event)" [options]="classesObservable">
                </lgd-typeahead>

                <div fxFlex="10">
                    <forge-icon-button (click)="addNewClass()">
                        <forge-icon *ngIf="!AddClass" name="add"></forge-icon>
                        <forge-icon *ngIf="AddClass" name="remove"></forge-icon>
                    </forge-icon-button>
                </div>
            </div>

            <div *ngIf="AddClass" class="mb20" fxLayout="row" fxLayoutAlign="space-between start">
                <lgd-text fxFlex="45" controlName="classCode" label="Class Code"
                          telemetry="Edit-ClassCode-AddInventoryItem-Inventory">
                </lgd-text>

                <lgd-text fxFlex="45" controlName="classDescription" label="Class Description"
                          telemetry="Edit-ClassDescription-AddInventoryItem-Inventory">
                </lgd-text>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between start" class="mb20">
                <lgd-number fxFlex="45" controlName="reorder" label="Reorder Point"
                            telemetry="Edit-Reorder-AddInventoryItem-Inventory">
                </lgd-number>

                <lgd-typeahead fxFlex="35" #unitLookup controlName="unit" label="Unit"
                               (searchTextChanged)="lookupUnits($event)" [options]="unitsObservable"
                               telemetry="Edit-Label-AddInventoryItem-Inventory">
                </lgd-typeahead>

                <div fxFlex="10">
                    <forge-icon-button (click)="addNewUnit()">
                        <forge-icon *ngIf="!AddUnit" name="add"></forge-icon>
                        <forge-icon *ngIf="AddUnit" name="remove"></forge-icon>
                    </forge-icon-button>
                </div>
            </div>

            <div *ngIf="AddUnit" fxLayout="row" fxLayoutAlign="space-between">
                <lgd-text fxFlex="45" controlName="unitCode" label="Unit Code"
                          telemetry="Edit-UnitCode-AddInventoryItem-Inventory">
                </lgd-text>

                <lgd-text fxFlex="45" controlName="unitDescription" label="Unit Description"
                          telemetry="Edit-UnitDescription-AddInventoryItem-Inventory">
                </lgd-text>
            </div>

            <div *ngIf="AddUnit">
                <lgd-number controlName="conversionFactor" label="Conversion Factor"
                            telemetry="Edit-ConversionFactor-AddInventoryItem-Inventory">
                </lgd-number>
            </div>

            <div *ngIf="!AddUnit" fxLayout="row" fxLayoutAlign="end center">
                <div>{{conversionString}}</div>
            </div>

            <mat-card appearance="outlined">
                <div fxLayout="row">
                    <lgd-typeahead fxFlex controlName="vendor" label="Vendor"
                                   (searchTextChanged)="lookupVendors($event)" [options]="vendorsObservable"
                                   telemetry="Edit-Vendor-AddInventoryItem-Inventory">
                    </lgd-typeahead>
                </div>

                <div fxLayout="row">
                    <lgd-text fxFlex="45" controlName="partNumber" label="Part #"
                              telemetry="Edit-Part#-AddInventoryItem-Inventory">
                    </lgd-text>

                    <lgd-currency fxFlex="45" controlName="price" label="Price per Unit"
                                  telemetry="Edit-Price-AddInventoryItem-Inventory" style="margin: 0 1rem;">
                    </lgd-currency>
                </div>
            </mat-card>
        </div>

        <mat-progress-bar [fxShow]="processing" mode="indeterminate"></mat-progress-bar>
    </form>

    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
        <command-bar [commands]="commands" telemetry="CmdBar-CommandKey-AddInventoryItem-Inventory"></command-bar>
    </div>

</div>